/* eslint-disable */

import { grey } from '@material-ui/core/colors';

/**
 * Create styles for `<DateText />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<DateText />` styles
 */
const dateTextStyles = ({ isDark, theme }) => ({
  todayLabel: {
    color: isDark() ? grey[600] : grey[400],
    marginLeft: theme.spacing(1),
  },
  subheaderContainer: {
    backgroundColor: '#fff',
    minHeight: 64,
    [theme.breakpoints.down(`xs`)]: {
      minHeight: 56,
    },
  },
});

export default dateTextStyles;
